// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "ExpressiveList-module--bx--text-truncate--end--dRMyW";
export var bxTextTruncateFront = "ExpressiveList-module--bx--text-truncate--front--KF6NO";
export var content = "ExpressiveList-module--content--K04Sx";
export var expressive_02 = "ExpressiveList-module--expressive_02--ZGZsV";
export var expressive_04 = "ExpressiveList-module--expressive_04--18wa3";
export var listRow = "ExpressiveList-module--listRow--5+WLg";
export var pictogramContent = "ExpressiveList-module--pictogramContent--CRO9B";
export var title = "ExpressiveList-module--title--rkwdG";